/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Data_Not_SynchronizedInputs */



/**
* | output |
* | --- |
* | "The data is not synchronized yet" |
*
* @param {Data_Not_SynchronizedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const data_not_synchronized = /** @type {((inputs?: Data_Not_SynchronizedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Data_Not_SynchronizedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The data is not synchronized yet")
	return /** @type {LocalizedString} */ ("Les données ne sont pas encore synchronisées")
});